
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';


import './services.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pservices = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be762" >

      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/aboutus"
        type=""
      >
        <>Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/services"
        type=""
      >
        <>Servicios</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactus"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgsvh2.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href={`/`}
        >
          
    <div id="iye9" className="">
    <>Ini</>
      <a
        target=""
        className=""
        id="id3bxh"
        href=""
        type=""
      >
        
      </a>
      <>cio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href={`/aboutus`}
        >
          
    <div id="i8s6k" className="">
    <>Nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href={`/services`}
        >
          
    <div id="ib721" className="">
    <>Servicios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>Blog</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactus"
        >
          
    <div id="ii21f" className="">
    <>Contacto</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="ib6b7" className="">
      
      <div id="iv94u" className="">
      
      <img
        className=""
        id="iwpbk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgxdbe.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i7dif"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgph1jxm.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ixytr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgza38.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ilriia"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="iskblh" className="">
      
      <div id="ii7y4h" className="">
      
      <img
        className=""
        id="iqs3e7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="iwisgl"
          href="#"
        >
          
      <img
        className=""
        id="idha68"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpiasyr.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i4rmpy"
          href="#"
        >
          
      <img
        className=""
        id="iepnei"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieb1l.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iy1hfx"
          href="#"
        >
          
      <img
        className=""
        id="iokirk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieyc5.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i6g4d8"
          href="#"
        >
          
      <img
        className=""
        id="inccm4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpifmoh.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
      <img
        className=""
        id="icmusm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i637ff" className="">
      
      <div id="i3mlod" className="">
      
      <div className="" id="iqb56p">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="ijf32v">
        <>Servicios</>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div id="i124bl" className="">
      
      <div className="" id="ip8x7b">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="idku6">
        <>CREAMOS
EXPERIENCIAS DIGITALES MEMORABLES: SITIOS, APPS Y CAMPAÑAS PENSADAS PARA
CONVERTIR.</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="icvsbl" className="">
      
      <img
        className=""
        id="ib6403"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgra7y9l.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i7c4v6" className="">
      
      <div
        id="itt9nf"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="i0oe9l" className="">
      
      <div id="ip516o" className="">
      
      <div className="" id="i0zr4n">
        <>En [Nombre de la agencia] combinamos creatividad y datos para construir soluciones digitales a la medida. Desde la estrategia y diseño UX hasta el desarrollo y la optimización de campañas, trabajamos contigo paso a paso para lograr objetivos reales: más clientes, más ventas y una marca más sólida.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ip1xoj" className="">
      
      <div className="" id="im7t1q">
        <>Nuestros Servicios</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ig0u23"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ig6qej" className="">
      
      <div id="iicatb" className="">
      
      <div id="i38fuz" className="">
      
      <div id="ie0vi4" className="">
      
      <div id="is2jmm" className="">
      
      <img
        className=""
        id="i3hnnv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgrauqn8.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i6fi8s" className="">
      
      <div id="i84waz" className="">
      
      <div className="" id="ic2anf">
        <>Estrategia Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="ii6dyj" className="">
      
      <div className="" id="iz3qyp">
        <>Ser la agencia referente en creatividad y tecnología en la región, reconocida por transformar retos complejos en experiencias digitales simples, útiles y memorables.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i490jp" className="">
      
      <div id="izkdsl" className="">
      
      <img
        className=""
        id="iq0nrc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgsc7v4w.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i1qmf3" className="">
      
      <div id="if85lz" className="">
      
      <div className="" id="i9zwj9">
        <>Branding & Identidad</>
      </div>
      <>
        </>
      </div>
      
      <div id="i0a8lx" className="">
      
      <div className="" id="ib72z9">
        <>Naming, posicionamiento, guías de marca y activos visuales coherentes que comunican confianza y profesionalismo.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ixp34r" className="">
      
      <div id="ig55bg" className="">
      
      <img
        className=""
        id="ie1p7j"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgrauqn8.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ivncpy" className="">
      
      <div id="ib76cy" className="">
      
      <div className="" id="ifocj6">
        <>Desarrollo Web & Apps </>
      </div>
      <>
        </>
      </div>
      
      <div id="i9ottl" className="">
      
      <div className="" id="iq87tj">
        <>Sitios y aplicaciones rápidas, seguras y escalables &#40;web, e-commerce y PWA). Entrega limpia y mantenimiento.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihkxux" className="">
      
      <div id="iwpwib" className="">
      
      <div id="irevzt" className="">
      
      <img
        className=""
        id="ixkzpw"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgsc2kbh.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iluh62" className="">
      
      <div id="inzfhl" className="">
      
      <div className="" id="i6rjrk">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="irw7mg" className="">
      
      <div className="" id="igiqul">
        <>Campañas de performance, SEO técnico, content marketing y gestión de redes para crecer tu audiencia y ventas.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ilf7pg" className="">
      
      <div id="i0e4xm" className="">
      
      <img
        className=""
        id="i11qr3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgsc2kbh.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="il5c8n" className="">
      
      <div id="i8g2vz" className="">
      
      <div className="" id="iqn3qe">
        <>Soporte & Optimización</>
      </div>
      <>
        </>
      </div>
      
      <div id="itwbxl" className="">
      
      <div className="" id="i2rriw">
        <>Monitoreo, optimización de conversiones &#40;CRO) y mantenimiento para que tu producto digital rinda siempre.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihp80h" className="">
      
      <div id="ig4ick" className="">
      
      <img
        className=""
        id="i8exgc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgsc7v4w.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ira6f4" className="">
      
      <div id="i6171t" className="">
      
      <div className="" id="isfukm">
        <>Diseño UX/UI</>
      </div>
      <>
        </>
      </div>
      
      <div id="ia8cqn" className="">
      
      <div className="" id="i9ilmr">
        <>Interfaces intuitivas y atractivas que convierten visitantes en clientes. Prototipos, testeos y diseño responsive.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i2ahwn"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="iqxuff" className="">
      
      <div id="" className="swiper mySwiper ">
      
      <div id="" className="swiper-wrapper ">
      
      <div id="itb2d5" className="swiper-slide ">
      
      <div id="ieh021" className="">
      
      <div id="i5w38a" className="">
      
      <div id="iwxf7j" className="">
      
      <img
        className=""
        id="id9tsm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpr7ru5.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iget9k" className="">
      
      <img
        className=""
        id="ioxp23"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7e2deg.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8g59i" className="">
      
      <div id="iczv5i" className="">
      
      <div className="" id="ipzpsr">
        <>“Pasamos de campañas dispersas a un sistema que vende solo. Reportes claros y crecimiento real.”</>
      </div>
      <>
        </>
      </div>
      
      <div id="iyy201" className="">
      
      <div className="" id="iyblcf">
        <>María López, Directora de Growth — RetailNow</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i0zimi" className="swiper-slide ">
      
      <div id="i9yl5u" className="swiper-slide ">
      
      <div id="i6y07i" className="">
      
      <div id="imcrzn" className="">
      
      <div id="ikgtl4" className="">
      
      <img
        className=""
        id="iegvh6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpr7ru5.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="il526s" className="">
      
      <img
        className=""
        id="idk8u9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgprf6t0.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ikm3b1" className="">
      
      <div id="i2g3p9" className="">
      
      <div className="" id="ii720b">
        <>“Pasamos de campañas dispersas a un sistema que vende solo. Reportes claros y crecimiento real.”</>
      </div>
      <>
        </>
      </div>
      
      <div id="ictf14" className="">
      
      <div className="" id="ia1qxl">
        <>María López, Directora de Growth — RetailNow</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="" className="swiper-button-next ">
      
      </div>
      
      <div id="" className="swiper-button-prev ">
      
      </div>
      
      <div id="" className="swiper-pagination ">
      
      </div>
      
      </div>
      
      <div className="" id="i4y777">
        
      <span className="" id="iammpf">
        <>Testimonios</>
      </span>
      
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="iz7z68" className="">
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="igh5jt" className="">
      
      <img
        className=""
        id="ixcgxf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpyckqh.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        
      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <div id="ih6ehn" className="">
      <>Agenda una reunión</>
      </div>
      
      </button>
      
      <img
        className=""
        id="i46teu"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpy5xbw.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i65bpz" className="">
      
      <div id="i2yoeq" className="">
      
      <img
        className=""
        id="i1wsi1"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpu3xum.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i9cjj5" className="">
      
      <div id="i5p5ct" className="">
      
      <div className="" id="iuwnnv">
        <>Tegucigalpa, Honduras</>
      </div>
      <>
        </>
      </div>
      
      <div id="ic2udh" className="">
      
      <div className="" id="i7ljte">
        <>+504 8747-5202</>
      </div>
      <>
        </>
      </div>
      
      <div id="ii33f8" className="">
      
      <div className="" id="iauc2i">
        <>info@origamih.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iqu5gn" className="">
      
        <a
          target=""
          className=""
          id="il2adk"
          href="/"
        >
          
      <div className="" id="idxk31">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i2kn9i"
          href="/aboutus"
        >
          
      <div className="" id="imlqq5">
        <>Nosotros</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="itz32f"
          href="/services"
        >
          
      <div className="" id="i934xq">
        <>Servicios</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="is143s"
          href="/blog"
        >
          
      <div className="" id="i41yjl">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ileryn"
          href="/contactus"
        >
          
      <div className="" id="i33cqc">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ijbjuw" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025 Origamih. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="ijsxl9"
          href="#"
        >
          
      <img
        className=""
        id="ih3cyr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgu1c31t.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pservices);
  